<template >
  <div class="knowledgeDialog">
    <el-dialog :title="title" :visible.sync="knowledgeDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="knowledgeForm" :model="knowledgeForm"  label-width="140px" :rules="rules">
        <el-form-item label="知识点名称"  class="is-required" prop="name" >
          <el-input v-model="knowledgeForm.name" :maxlength="200"> </el-input>
        </el-form-item>
        <el-form-item label="排序值"  class="is-required" prop="ordinal" >
          <el-input v-model.trim="knowledgeForm.ordinal" placeholder="请输入排序值..." maxlength="9"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="knowledgeDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import knowledgeService from '@/service/knowledgeService'
export default {
  props: {
    id: {
      type: Number
    },
    rowData: Object,
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      title: '编辑知识点',
      loading: false,
      knowledgeForm: {
        name: '',
        ordinal: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入知识点名称', trigger: 'change'}
        ],
        ordinal: [
          {required: true, message: '请输入序列号', trigger: 'blur'},
          {pattern: /^[0-9]*$/, message: '请输入数字', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  methods: {
    async save () {
      this.loading = true
      this.$refs.knowledgeForm.validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            this.knowledgeForm.name = this.knowledgeForm.name.trim()
            await knowledgeService.save(this.knowledgeForm)
            // @success
            this.$emit('success', this.knowledgeForm.name)
            this.loading = false
            this.knowledgeDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
        this.loading = false
      })
    }
  },
  watch: {
    knowledgeDialogVisible (newVal, oldVal) {
      this.title = '新增'
      if (newVal) {
        if (this.$refs.knowledgeForm) {
          this.$refs.knowledgeForm.resetFields()
        }
        // 加载初始化数据
        this.knowledgeForm = {
          id: this.$props.rowData.id,
          subjectId: this.$props.rowData.subjectId,
          ordinal: this.$props.rowData.ordinal,
          name: this.$props.rowData.name,
          parentId: this.$props.rowData.parentId,
          type: 'TESTING_POINT'
        }
        this.title = '编辑知识点'
      }
    }
  },
  computed: {
    knowledgeDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
  .knowledgeDialog .el-form-item .el-input{
    width:75%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/knowledge-manage/edit-dialog/index.vue